import React, { useState, useEffect } from 'react';
import { CompanyStyles } from '../company/CompanyStyles';
import { MobileDrawer } from '../company/MobileDrawer';
import { DispatchModal } from '../company/DispatchModal';
import { ProductsHeader } from './ProductsHeader';
import { ProductsHero } from './ProductsHero';
import { ProductFeatures } from './ProductFeatures';
import { Footer } from '../landing/Footer';
import { BriefingModal } from '../landing/BriefingModal';

// Products / Platform subpage (route: /products).
export default function ProductsPage() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [dispatchOpen, setDispatchOpen] = useState(false);
  const [dispatchContext, setDispatchContext] = useState('');

  const openBriefing = () => { setMobileOpen(false); setModalOpen(true); };
  const openDispatch = (context) => { setDispatchContext(context); setDispatchOpen(true); };

  useEffect(() => {
    document.title = 'The Frontier Platform | Full-Stack Deal Architecture';
    if (!window.location.hash) window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    document.body.style.overflow = (mobileOpen || modalOpen || dispatchOpen) ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [mobileOpen, modalOpen, dispatchOpen]);

  useEffect(() => {
    if (!window.location.hash) return;
    const id = window.location.hash.slice(1);
    let tries = 0;
    const tick = () => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
      else if (tries++ < 20) setTimeout(tick, 100);
    };
    setTimeout(tick, 100);
  }, []);

  return (
    <div className="company-root min-h-screen bg-[#FBFBFB] text-stone-900 overflow-x-clip">
      <CompanyStyles />
      <ProductsHeader onOpenBriefing={openBriefing} onOpenDispatch={openDispatch} onToggleMobile={() => setMobileOpen((v) => !v)} />
      <MobileDrawer open={mobileOpen} onClose={() => setMobileOpen(false)} onOpenBriefing={openBriefing} />

      <ProductsHero />
      <ProductFeatures onOpenBriefing={openBriefing} />
      <Footer onOpenBriefing={openBriefing} />

      <BriefingModal isOpen={modalOpen} onClose={() => setModalOpen(false)} inquiryType="" />
      <DispatchModal open={dispatchOpen} onClose={() => setDispatchOpen(false)} context={dispatchContext} />
    </div>
  );
}
